export default __webpack_public_path__ + "static/media/winner_logo_v4.98cf2952.png";